/* eslint-disable no-underscore-dangle */
const debug = require('debug')('knack.api-wrapper');
const _ = require('lodash');

async function getApplication(accountSlug, applicationSlug) {
  debug('getApplication()');

  if (_.isNil(accountSlug)) {
    throw new Error('accountSlug argument is required');
  }

  if (_.isNil(applicationSlug)) {
    throw new Error('applicationSlug argument is required');
  }

  const application = await this.axios({
    url: `/builder/${accountSlug}/application/${applicationSlug}`,
    method: 'GET',
  });

  this._clientSubdomainMap = application.clientSubdomainMap;
  this._updateInternals(application.accountId, application.id);

  return application;
}

async function getApplicationPages(accountSlug, applicationSlug, options = {}) {
  debug('getApplicationPages()');

  const { topLevelPagesOnly } = options;

  if (_.isNil(accountSlug)) {
    throw new Error('accountSlug argument is required');
  }

  if (_.isNil(applicationSlug)) {
    throw new Error('applicationSlug argument is required');
  }

  const pages = await this.axios({
    url: `/builder/${accountSlug}/application/${applicationSlug}/pages`,
    method: 'GET',
    params: {
      topLevelPagesOnly,
    },
  });

  return pages;
}

module.exports = {
  getApplication,
  getApplicationPages,
};
